/**
 * Do an async thing according to a condition.
 *
 * Usage:
 *
 * If(!storeInfrastructures.infrastructures.size)
 *   .doAsync(storeInfrastructures.fetchInfrastructures.bind(storeInfrastructures))
 *   .then(() =>
 */
export function If(condition: boolean) {
  return {
    doAsync: (fn: () => Promise<void>) => {
      if (!condition) {
        return Promise.resolve()
      }
      return fn()
    }
  }
}
